// @flow
export function createSingleFieldFormData(
  value: File | Blob,
  fieldName: string = 'file',
  addionalData: {[key: string]: string} = {}
): FormData {
  const fd = new FormData();
  fd.append(fieldName, value);
  Object.keys(addionalData).forEach(k => fd.append(k, addionalData[k]));
  return fd;
}

export function createMultiFieldFormData(
  files: File[] | Blob[],
  fieldName: string = 'files',
  addionalData: {[key: string]: string} = {}
): FormData {
  const fd = new FormData();
  files.forEach((file, i) => fd.append(`${fieldName} ${i}`, file));
  Object.keys(addionalData).forEach(k => fd.append(k, addionalData[k]));
  return fd;
}

export function getFilledValues(
  values: {[key: string]: any},
  testFields: string[] = []
): any {
  const v = {...values};
  testFields.forEach((tf: string) => {
    if (
      !values[tf]
      /*typeof values[tf] === 'undefined' ||
      values[tf] === null ||
      isNaN(values[tf])*/
    )
      delete v[tf];
  });
  return (v: any);
}
